`<ResponsiveXYFrame />` is a wrapper around XYFrame that makes its height and/or width responsive to changes in the size of its container. It has all the attributes of XYFrame along with the following:

## Responsive Attributes

### responsiveWidth { _bool_ }

Whether the width (`size[0]`) changes on container size change to match the size of the container.

### responsiveHeight { _bool_ }

Whether the height (`size[1]`) changes on container size change to match the size of the container.

`<ResponsiveMinimapXYFrame />` is a wrapper around MinimapXYFrame that makes its height and/or width responsive to changes in the size of its container. It has all the attributes of MinimapXYFrame along with the following:

## Responsive Attributes

### responsiveWidth { _bool_ }

Whether the width (`size[0]`) changes on container size change to match the size of the container.

### responsiveHeight { _bool_ }

Whether the height (`size[1]`) changes on container size change to match the size of the container.
